import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { TreeGeneratorService } from 'src/app/core/datasets/tree-generator.service';
import { IGroup } from '@models/general/group';
import { Subscription } from 'rxjs';
import { GroupsTreeNode } from 'src/app/core/datasets/tree.interface';
import { v4 } from 'uuid';
import { AdminService } from '../admin/admin.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TopBarService } from 'src/app/top-bar/top-bar.service';

@Component({
  selector: 'restoreid-group-list-admin',
  templateUrl: './group-list.component.html',
  styleUrls: [
    'group-list.component.scss'
  ]
})
export class GroupListAdminComponent implements OnInit, OnDestroy {
  groupList: IGroup[] = [];
  groupTreeList: GroupsTreeNode[] = [];

  selectedGroup?: IGroup;

  private _groupChangeSubscription?: Subscription;

  constructor(
    private _topBarService: TopBarService,
    private _treeGenerator: TreeGeneratorService,
    private _adminService: AdminService,
    private _authService: AuthService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _changeDetector: ChangeDetectorRef)
    {
      this._topBarService.setTitle('Group List');
    }

  ngOnDestroy(): void {
    this._groupChangeSubscription?.unsubscribe();
  }

  addNewGroup() {
    this._router.navigate(
      [],
      {
        relativeTo: this._activatedRoute,
        queryParams: {
          id: v4()
        }
      }
    );
  }

  async ngOnInit() {
    await this._generateTree();

    this._groupChangeSubscription = this._adminService.changeSelectedGroup.subscribe(result => {
      this._router.navigate(
        [],
        {
          relativeTo: this._activatedRoute,
          queryParams: {
            id: result
          }
        }
      );
    })

    this._adminService.groupUpdated.subscribe(async _ => {
      await this._generateTree();
    });

    this._activatedRoute.queryParams.subscribe(params => {
      this.doGroupSelected(params['id'])!;

      if (!this.selectedGroup) {
        this.selectedGroup = {
          id: params['id']
        } as IGroup;
      }
      this._changeDetector.markForCheck();
    });
  }

  private async _generateTree() {
    this.groupList = await this._adminService.getGroups(true, this._authService.loggedInUserId!, this._authService.loggedInUser?.isadmin!);
    this.groupTreeList = this._treeGenerator.createGroupTree(this.groupList);
    this._changeDetector.markForCheck();
  }

  doGroupSelected(selectedNode: string) {
    this.selectedGroup = this.groupList.find(group => group.id === selectedNode)
  }
}
